import { useEffect, useState } from 'react';

import {
    getDefaultOptionId,
    getXAxisColumnOptions,
    getXAxisGroupByOptions,
} from 'components/pages/PackArchitecture/packArchitectureMeta.helpers';
import type { PpaMetaControlNode, PricePackArchitectureMetaResponse } from 'components/pages/PackArchitecture/packArchitectureMeta.types';

type UsePackArchitectureAxisInitializationParams = {
    meta: PricePackArchitectureMetaResponse | undefined;
    xAxisConfig?: PpaMetaControlNode;
    yAxisConfig?: PpaMetaControlNode;
    bubbleRepresentsConfig?: PpaMetaControlNode;
    bubbleSizeConfig?: PpaMetaControlNode;
    heatMapToggle?: PpaMetaControlNode;
    setXAxis: (value: string) => void;
    setYAxis: (value: string) => void;
    setBubbleRepresents: (value: string) => void;
    setBubbleSize: (value: string) => void;
    setShowHeatMap: (value: boolean) => void;
};

export function usePackArchitectureAxisInitialization({
    meta,
    xAxisConfig,
    yAxisConfig,
    bubbleRepresentsConfig,
    bubbleSizeConfig,
    heatMapToggle,
    setXAxis,
    setYAxis,
    setBubbleRepresents,
    setBubbleSize,
    setShowHeatMap,
}: UsePackArchitectureAxisInitializationParams) {
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        if (!meta || isInitialized) return;

        const xAxisGroupByOptions = getXAxisGroupByOptions(xAxisConfig);
        const xAxisColumnOptions = getXAxisColumnOptions(xAxisConfig);

        setXAxis(getDefaultOptionId([...xAxisGroupByOptions, ...xAxisColumnOptions]));
        setYAxis(getDefaultOptionId(yAxisConfig?.column_options ?? []));
        setBubbleRepresents(getDefaultOptionId(bubbleRepresentsConfig?.group_by_options ?? []));
        setBubbleSize(getDefaultOptionId(bubbleSizeConfig?.column_options ?? []));
        setShowHeatMap(Boolean(heatMapToggle?.default_value));
        setIsInitialized(true);
    }, [
        bubbleRepresentsConfig?.group_by_options,
        bubbleSizeConfig?.column_options,
        heatMapToggle?.default_value,
        isInitialized,
        meta,
        setBubbleRepresents,
        setBubbleSize,
        setShowHeatMap,
        setXAxis,
        setYAxis,
        xAxisConfig,
        yAxisConfig?.column_options,
    ]);

    return isInitialized;
}
